<template>
<div>
  <headerComponent />
  <div class="Center">
    <div class="Wrapper">
      <template v-if="campaignHyperlink && campaignImg">
        <a :href="campaignHyperlink" target="_blank">
          <img :src="campaignImg" />
        </a>
      </template>
      <template v-if="!campaignHyperlink && campaignImg">
        <img :src="campaignImg" />
      </template>
      <catelog :scrollY="scrollY" @setCampaignInfo="setCampaignInfo" />
    </div>
  </div>
  <footerComponent />
  <alert
    v-if="showAlert"
    v-on:closeAlertTips="closeAlertTips"
    :message="showAlertMsg" />
</div>
</template>

<script>
import alert from "../components/common/alert.vue";
import headerComponent from "../components/common/header.vue";
import footerComponent from "../components/common/footer.vue";
import catelog from "../components/common/catelog.vue";

export default {
  name: "Home",
  data() {
    return {
      showAlert: false,
      showAlertMsg: "",
      isStopScrolling: false,
      dueToBottomGap: window.innerHeight / 2,
      scrollY: 0,
      windowW: window.screen.width,
      campaignInfo: null,
      campaignImg: null,
      campaignHyperlink: null,
    };
  },
  created () {
    
  },
  mounted() {
    if (window.alertMessage) {
      const message = new this.fridayMessage(window.alertMessage)
      message.init()
      message.show()
      delete window.alertMessage
    }
    window.onscroll = () => {
      this.scrollY = window.scrollY;
    };
  },
  methods: {
    setCampaignInfo(data) {
      this.campaignInfo = data;

      if (data.otherInformation) {
        const { hyperlink, image } = data.otherInformation;
        if (hyperlink && /^https/i.test(hyperlink)) {
          this.campaignHyperlink = hyperlink;
        }
        if (image && /^https/i.test(image)) {
          this.campaignImg = image;
        }
      }
    },
    alertTips(message) {
      this.showAlertMsg = message;
      this.showAlert = true;
    },
    closeAlertTips() {
      this.showAlert = false;
    },
    stopBodyScroll(action) {
      const body = document.querySelector("html");
      if (!this.isStopScrolling) {
        body.style = "padding:0;margin:0;overflow:hidden;height:100%";
        this.isStopScrolling = !this.isStopScrolling;
      }
      if (action === "close") {
        body.style = "padding:0;margin:0;";
        this.isStopScrolling = false;
      }
    }
  },
  components: {
    alert,
    headerComponent,
    footerComponent,
    catelog
  },
};
</script>

<style lang="scss">
@import "../style/reset.module.scss";
@import "../style/flex.module.scss";
@import "../style/global.module.scss";
@import "../style/header.module.scss";
@import "../style/footer.module.scss";
</style>

<style lang="scss" scoped>
.Center {
  .Wrapper {
    position: relative;
  }
}
</style>
